import { getIsOpera, getIsSafari } from '../common/utils/utils';
const project = require('../scripts/configs/project.json');

var getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        height = _node$getBoundingClie.height,
        width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    const boundingClientRect = currentTarget.getBoundingClientRect();
    const targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = getDimensions(currentTarget),
        targetWidth = _getDimensions3.width,
        targetHeight = _getDimensions3.height;

    let width = window.innerWidth;
    const zoom = Number(window.getComputedStyle(document.querySelector('html'), null).zoom);

    let isSafari = getIsSafari();
    let isZoom = zoom === zoom && zoom < 1 && width < 1650 && width >= 1300;

    //додаткова умова для відображення тултипів в safari
    if (effect === 'float' || (isSafari && isZoom)) {
        var getWithZoom = (mouse) => {
            if (isZoom) {
                return mouse / zoom;
            }
            return mouse;
        };
        return {
            mouseX: getWithZoom(e.clientX),
            mouseY: getWithZoom(e.clientY)
        };
    }
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
var calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') {
        offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    }
    for (var key in offset) {
        if (key === 'top') {
            extraOffsetY -= parseInt(offset[key], 10);
        } else if (key === 'bottom') {
            extraOffsetY += parseInt(offset[key], 10);
        } else if (key === 'left') {
            extraOffsetX -= parseInt(offset[key], 10);
        } else if (key === 'right') {
            extraOffsetX += parseInt(offset[key], 10);
        }
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};

var getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while (currentParent) {
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (
            computedStyle.getPropertyValue('transform') !== 'none' ||
            computedStyle.getPropertyValue('will-change') === 'transform'
        )
            break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = (currentParent && currentParent.getBoundingClientRect().top) || 0;
    var parentLeft = (currentParent && currentParent.getBoundingClientRect().left) || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor) n = o.constructor.name;
    if (n === 'Map' || n === 'Set') return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = (typeof Symbol !== 'undefined' && o[Symbol.iterator]) || o['@@iterator'];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || (allowArrayLike && o && typeof o.length === 'number')) {
            if (it) o = it;
            var i = 0;
            var F = function () {};
            return {
                s: F,
                n: function () {
                    if (i >= o.length)
                        return {
                            done: true
                        };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function (e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError(
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
        );
    }
    var normalCompletion = true,
        didErr = false,
        err;
    return {
        s: function () {
            it = it.call(o);
        },
        n: function () {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function (e) {
            didErr = true;
            err = e;
        },
        f: function () {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally {
                if (didErr) throw err;
            }
        }
    };
}
function getPosition(e, target, node, place, desiredPlace, effect, offset) {
    // TODO ZOOM
    let isSafari = getIsSafari();
    let isOpera = getIsOpera();

    var getWithZoom = (scroll) => {
        let width = window.innerWidth;
        const zoom = Number(window.getComputedStyle(document.querySelector('html'), null).zoom);
        if (project.zooming && zoom === zoom && zoom < 1 && width < 1650 && width >= 1300) {
            return scroll / zoom;
        }
        return scroll;
    };

    const checkNotSafari = (scroll) => {
        return isSafari || isOpera ? scroll : getWithZoom(scroll);
    };
    // TODO ZOOM
    var _getDimensions = getDimensions(node),
        tipWidth = checkNotSafari(_getDimensions.width),
        tipHeight = checkNotSafari(_getDimensions.height);
    var _getDimensions2 = getDimensions(target),
        targetWidth = checkNotSafari(_getDimensions2.width),
        targetHeight = checkNotSafari(_getDimensions2.height);
    var _getCurrentOffset = getCurrentOffset(e, target, effect),
        mouseX = checkNotSafari(_getCurrentOffset.mouseX),
        mouseY = checkNotSafari(_getCurrentOffset.mouseY);
    var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = calculateOffset(offset),
        extraOffsetX = checkNotSafari(_calculateOffset.extraOffsetX),
        extraOffsetY = checkNotSafari(_calculateOffset.extraOffsetY);
    var windowWidth = checkNotSafari(window.innerWidth);
    var windowHeight = checkNotSafari(window.innerHeight);
    var _getParent = getParent(node),
        parentTop = checkNotSafari(_getParent.parentTop),
        parentLeft = checkNotSafari(_getParent.parentLeft);

    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };

    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside('top'),
        bottom: inside('bottom'),
        left: inside('left'),
        right: inside('right')
    };
    function choose() {
        var allPlaces = desiredPlace.split(',').concat(place, ['top', 'bottom', 'left', 'right']);
        var _iterator = _createForOfIteratorHelper(allPlaces),
            _step;
        try {
            for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
            // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }

    if (isNewState) {
        return {
            isNewState: true,
            newState: {
                place: newPlace
            },
            position: {
                left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
                top: parseInt(getTipOffsetTop(place) - parentTop, 10)
            }
        };
    }
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}

export default getPosition;
